export const LeadCloseReasonsEnum = {
  lookupTypeId: 1208,
};
export const LeadUnqualifiedeasonsEnum = {
  lookupTypeId: 3208,
  lookupTypeName: 'UnqualifiedReasons'
};
